import React, { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import { useParams } from 'react-router-dom';
import List from 'src/components/grid.component';
import moment from 'moment';
const PaymentsDetails=()=>{
 const gridRef = React.createRef();
 let { custId } = useParams();
const paymentURL = process.env.REACT_APP_GRID_API + `Merchant/Admin/Merchant/${custId}/All`
const dateFormat = process.env.REACT_APP_DATETIME_FORMAT
useEffect(()=>{
    gridRef.current?.refreshGrid();
},[])

const renderCustomCell = (prop, column) => {
    const customcells = {
        "customerName": (payments) => (<td><div><button className='gridLink c-pointer batch-filename px-0' onClick={() => navigate(`/customer/${payments?.dataItem?.customerId}/Payments`)}>{(payments?.dataItem?.customerName)}</button></div></td>),
        "createdDate" : (payments)=>(<td><div className="gridLink text-white" >{payments.dataItem.createdDate ? <> {moment.utc(payments.dataItem.createdDate).local().format(dateFormat)}</> : payments.dataItem.createdDate}</div></td>),
        "modifiedDate":(payments)=>(<td><div className="gridLink text-white" >{payments.dataItem.modifiedDate ? <>{moment.utc(payments.dataItem.modifiedDate).local().format(dateFormat)}</> :  payments.dataItem.modifiedDate}</div></td>),
        "amountInUSD":(payments)=>(<td><div><NumberFormat value={payments?.dataItem?.amountInUSD || 0} displayType="text" thousandSeparator={true} /></div></td>),
    }
    if (customcells[column.field])
        return customcells[column.field](prop);
}
    return(
        <div>
           <List
            showExcelExport={true}
            url={paymentURL}
            screenName={"Customers_Payments"}
            ref={gridRef}
            renderCustomCell={renderCustomCell}
            pSize={10}
            hasFooter={true}
           className="custom-grid card-historylist"
        />
       </div>
    )
}
export default PaymentsDetails